// src/data/exercises/L4_01.js

const accountOptions = [
  '売上', '買掛金', '備品', '売掛金', '仕入'];

export const L4_01 = {
  title: '簿記　3級（第212-1回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
      content: {
       parts: [
    { "type": "ruby", "text": "先日", "ruby": "せんじつ" },
    { "type": "text", "value": "、" },
    { "type": "ruby", "text": "掛", "ruby": "か" },
    { "type": "text", "value": "けて" },
    { "type": "ruby", "text": "販売", "ruby": "はんばい" },
    { "type": "text", "value": "した" },
    { "type": "ruby", "text": "商品", "ruby": "しょうひん" },
    { "type": "text", "value": "のうち、￥700が" },
    { "type": "ruby", "text": "品違", "ruby": "しなちが" },
    { "type": "text", "value": "いのため" },
    { "type": "ruby", "text": "返品", "ruby": "へんぴん" },
    { "type": "text", "value": "された。" }
],
      },
      table: {
        options: accountOptions,
      },
      answer: [
        { debitAccount: '売上', debitAmount: 700, creditAccount: '売掛金', creditAmount: 700 },
      ],

      // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {
        parts: [
          { type: 'text', value: '「①一番大切なことばは、返品。\n' },
          { type: 'text', value: '次に、仕入の返品？売上の返品？\n' },
          { type: 'text', value: 'この問題は、販売（売上の返品）\n' },
          { type: 'styled', value: '売上の消滅（マイナス）は、借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '②売上なかったと考えるので、売上の反対を仕訳する。\n' },
          { type: 'styled', value: '売掛金の減少（マイナス）は、貸方（右・Ｃｒ）に記入します。', color: 'red', bold: true },
        ]
      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`①一番大切なことばは、返品。
次に、仕入の返品？売上の返品？

この問題は、販売（売上の返品）

②売上なかったと考えるので、売上の反対を仕訳する。`,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
          parts: [
          { type: 'text', value: '「①一番大切なことばは、返品。\n' },
          { type: 'text', value: '次に、仕入の返品？売上の返品？\n' },
          { type: 'text', value: 'この問題は、販売（売上の返品）\n' },
          { type: 'styled', value: '売上の消滅（マイナス）は、借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '②売上なかったと考えるので、売上の反対を仕訳する。\n' },
          { type: 'styled', value: '売掛金の減少（マイナス）は、貸方（右・Ｃｒ）に記入します。', color: 'red', bold: true },
        ]
          }
        ],
       
        
      },
    },
  ],
};